// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.2 (commit 4b41cf3d71aa85cd4e75c96cbb54324481ee0b27).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";
import { ProjectileInfo as __ProjectileInfo } from "./projectile_info_type";

export type EnemyType = {
  typeId: number,
  maxHealth: number,
  speed: number,
  size: number,
  experience: number,
  projectileInfo: __ProjectileInfo,
};

/**
 * A namespace for generated helper functions.
 */
export namespace EnemyType {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("typeId", AlgebraicType.createI32Type()),
      new ProductTypeElement("maxHealth", AlgebraicType.createI32Type()),
      new ProductTypeElement("speed", AlgebraicType.createI32Type()),
      new ProductTypeElement("size", AlgebraicType.createF32Type()),
      new ProductTypeElement("experience", AlgebraicType.createI32Type()),
      new ProductTypeElement("projectileInfo", __ProjectileInfo.getTypeScriptAlgebraicType()),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: EnemyType): void {
    EnemyType.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): EnemyType {
    return EnemyType.getTypeScriptAlgebraicType().deserialize(reader);
  }

}


